import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { getChapter } from "./api";
import { loaderStart, loaderEnd } from "../../components/loader"

import '../Question-bank/questionbank.css'
import './chapterpage.css'
import BackButton from '../../components/backButton'

const ChapterPage = () => {
    const { ...params } = useParams()
    const [data, setData] = useState([])
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        if (params.code) {
            getData()
        }
    }, [])

    const getData = async () => {
        // The screen previously fetched with no loading indicator at all, so it
        // sat blank and looked broken until the response landed.
        loaderStart()
        let data = await getChapter(params.code)
        if (data.code) {
            setData(data.data)
        }
        setLoaded(true)
        loaderEnd()
    }

    return (
        <div className='qb_page'>
            <BackButton to='/subject-page' />
            <nav className='qb_crumbs'>
                <Link to='/question-bank'>Question Bank</Link>
                <span className='qb_crumb_sep'>/</span>
                <Link to='/subject-page'>Subjects</Link>
                <span className='qb_crumb_sep'>/</span>
                <span>{params.code}</span>
            </nav>

            <div className='qb_header'>
                <h1 className='qb_title'>Chapters</h1>
                <p className='qb_subtitle'>
                    Subject <b>{params.code}</b>
                    {data.length > 0
                        ? ` · ${data.length} chapter${data.length === 1 ? '' : 's'}`
                        : ''}
                </p>
            </div>

            {data.length > 0 ? (
                <div className='qb_grid'>
                    {data.map((d, i) => (
                        // Opened via window.open on a div before — no keyboard access
                        // and no middle-click. A real link behaves like a link.
                        <a
                            key={d.file || i}
                            href={process.env.REACT_APP_FILE_URL + d.file}
                            target='_blank'
                            rel='noreferrer'
                            className='qb_card'
                        >
                            <span className='qb_card_code'>Chapter {i + 1}</span>
                            <p className='qb_card_name'>{d.name}</p>
                            <span className='qb_card_meta'>PDF</span>
                            <i className='fa fa-file-pdf qb_card_icon' aria-hidden='true'></i>
                        </a>
                    ))}
                </div>
            ) : loaded ? (
                <p className='qb_empty'>No chapters are available for this subject yet.</p>
            ) : null}
        </div>
    )
}

export default ChapterPage
